import { inAssistantTools } from '../../AssistantToolRegistry';
import { GenerateImageToolSupport } from './GenerateImageToolSupport';
import { GetObjectsToolSupport } from './GetObjectsToolSupport';
import { SwitchModeSupport } from './SwitchModeSupport';

export const inCoreAssistantTools = () =>
    inAssistantTools(
        GetObjectsToolSupport,
        SwitchModeSupport,
        GenerateImageToolSupport
    );
